import HeightInput from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/HeightInput';
import WeightInput from 'pages/Dashboard/pages/Charts/pages/Details/components/Demographics/WeightInput';
import React from 'react';

export default function BMIInputs() {
  return (
    <div className="flex flex-col gap-form-row mb-2">
      <div className="flex items-end gap-form-field">
        <HeightInput />
      </div>
      <WeightInput className="!w-full" />
    </div>
  );
}
